import React from 'react';
import { inject, observer } from 'mobx-react';
import { makeStyles } from '@material-ui/core/styles';
import { StuffList } from '../../stuff';
import TooltipBox from './TooltipBox';

// 물품 및 수량(데스크톱) — 자체 물품 라이브러리(components/stuff)로 그린다. 수량이 바뀌면 예상 운임을 다시 조회한다.
// 수량 상한은 옛 드롭다운과 같다(서류 100 · 소박스 50 · 중박스 40 · 대박스 24 · 나머지 100).
const MAX_BY_NAME = { documentCnt: 100, smallBoxCnt: 50, heavyBoxCnt: 40, greateBoxCnt: 24 };

const useStyles = makeStyles(() => ({
  root: {
    width: 440,
    maxWidth: '100%',
    paddingTop: 40,
  },
}));

function GoodsAndCount({ item, qsStore }) {
  const cs = useStyles();
  const { handleOptions, orderCalAPI, options } = qsStore;

  const handleChange = async (name, value) => {
    await handleOptions(name, value);
    if (name !== 'etcDesc') await orderCalAPI();
  };

  const items = item.map((it) => ({ ...it, max: it.max || MAX_BY_NAME[it.name] || 100 }));
  // 스토어 옵션을 펼쳐 넘긴다 — observer 가 각 수량 키를 추적해 스테퍼 값이 바로 바뀐다
  const values = { ...options };

  return (
    <div className={cs.root}>
      <StuffList
        items={items}
        values={values}
        onChange={handleChange}
        renderHelp={(it) => <TooltipBox title={it.tipTitle} context={it.tipContext} total={it.total} />}
      />
    </div>
  );
}

export default inject('qsStore')(observer(GoodsAndCount));
